import { render, staticRenderFns } from "./ExportCustomerSurvey.vue?vue&type=template&id=63b248d9&"
import script from "./ExportCustomerSurvey.vue?vue&type=script&lang=js&"
export * from "./ExportCustomerSurvey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports